import { connect } from 'react-redux';
import { getFetching } from '../../redux/Guest/selectors/visit';
import { getGuestVisitSearchQuery } from '../../redux/Guest/selectors/components/visit-search';
import { updateGuestVisitSearchQuery } from '../../redux/Guest/actions/components/visit-search';
import { clearGuestVisits } from '../../redux/Guest/actions/visit';
import { fetchGuestVisits } from '../../redux/Guest/sagas/routines';
import VisitSearch from '../../components/guest/VisitSearch';
import { getPaginationQueryOptions } from '../../redux/Guest/selectors/visit/pagination';
import { getAll as getUserLocationOptions } from '../../redux/Guest/selectors/user-location-options';

function mapStateToProps(state, props) {
  const locationOptions = getUserLocationOptions(state);
  const searchQuery = getGuestVisitSearchQuery(state);
  const paginationQuery = getPaginationQueryOptions(state);
  const queryOptions = { ...paginationQuery, ...searchQuery, page: 1 };
  return {
    ...props,
    searchQuery,
    queryOptions,
    locationOptions,
    isFetching: getFetching(state)
  };
}

function mapDispatchToProps(dispatch) {
  return {
    onSubmit: queryOptions => {
      dispatch(clearGuestVisits());
      dispatch(fetchGuestVisits(queryOptions));
    },
    onChange: query => {
      dispatch(updateGuestVisitSearchQuery(query));
    },
    onReset: defaultQuery => {
      dispatch(clearGuestVisits());
      dispatch(fetchGuestVisits(defaultQuery));
      dispatch(updateGuestVisitSearchQuery(defaultQuery));
    }
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(VisitSearch);
